import { render, staticRenderFns } from "./ArticleTile.vue?vue&type=template&id=4ac51f3f&scoped=true"
import script from "./ArticleTile.vue?vue&type=script&lang=ts"
export * from "./ArticleTile.vue?vue&type=script&lang=ts"
import style0 from "./ArticleTile.vue?vue&type=style&index=0&id=4ac51f3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac51f3f",
  null
  
)

export default component.exports